import * as tslib_1 from "tslib";
import getSearchFeedbackCustomTags from '../helpers/getSearchFeedbackCustomTags';
import sendSearchFeedback from '../helpers/sendSearchFeedback';
import { observer } from 'mobx-react';
import { Link } from 'office-ui-fabric-react/lib/components/Link';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { DialogResponse } from 'owa-confirm-dialog';
import { lazySetSelectedPivot } from 'owa-diagnostics';
import { toggleCharm } from 'owa-header-store';
import { SEARCH_DIAGNOSTICS_PANEL_KEY, searchDiagnosticsStore } from 'owa-search-diagnostics';
import { format } from 'owa-strings';
import { showUserVoiceSuggestionDialog } from 'owa-uservoice';
import * as React from 'react';
var styles = require('./SearchInContextFeedbackDialog.scss');
var classNames = require('classnames/bind');
// this feature can NEVER ship beyond MSIT since it contains PII,
// so we store our strings locally (so that they don't get localized)
var unlocalizedStrings = {
    dialogTitle: 'What issues did you encounter?',
    feedbackCommentsPlaceholder: 'Tell us what happened or how we can improve',
    feedbackLauncherLink: 'Submit search feedback',
    linkSeparator: '|',
    viewDiagnosticsLink: 'View diagnostics',
    searchTimeText: '({0} sec)',
    ticketTitle: 'New Ticket for Search In-Context Feedback',
};
// User Voice teams using this component
export var UserVoiceSearchTeam;
(function (UserVoiceSearchTeam) {
    UserVoiceSearchTeam[UserVoiceSearchTeam["MailSearch"] = 0] = "MailSearch";
    UserVoiceSearchTeam[UserVoiceSearchTeam["CalendarSearch"] = 1] = "CalendarSearch";
})(UserVoiceSearchTeam || (UserVoiceSearchTeam = {}));
var SearchInContextFeedbackDialog = /** @class */ (function (_super) {
    tslib_1.__extends(SearchInContextFeedbackDialog, _super);
    function SearchInContextFeedbackDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getLastSearchRequestTimeInSeconds = function () {
            var searchInstrumentationEntries = searchDiagnosticsStore.searchInstrumentationList
                .slice()
                .reverse();
            for (var _i = 0, searchInstrumentationEntries_1 = searchInstrumentationEntries; _i < searchInstrumentationEntries_1.length; _i++) {
                var instrumentation = searchInstrumentationEntries_1[_i];
                if (instrumentation.PageNumber == 0 &&
                    instrumentation.SearchQueryId == _this.props.currentSearchQueryId) {
                    return instrumentation.ClientJSEndToEndTime / 1000.0;
                }
            }
            return 0;
        };
        return _this;
    }
    SearchInContextFeedbackDialog.prototype.render = function () {
        var _this = this;
        var lastSearchRequestTime = this.getLastSearchRequestTimeInSeconds();
        var searchTimeString = format(unlocalizedStrings.searchTimeText, lastSearchRequestTime);
        return (React.createElement("div", { className: classNames(this.props.cssClass, styles.linkContainer) },
            React.createElement(Link, { onClick: function () { return _this.showSearchInContextFeedbackDialog(_this.props.userVoiceTeam); }, getStyles: function () { return ({
                    root: {
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '12px',
                        marginRight: '16px',
                    },
                }); } },
                React.createElement(Icon, { iconName: "Info" /* Info */, className: styles.linkIcon }),
                unlocalizedStrings.feedbackLauncherLink),
            React.createElement(Link, { getStyles: function () { return ({
                    root: {
                        alignItems: 'center',
                        display: 'flex',
                        fontSize: '12px',
                    },
                }); }, onClick: function () {
                    toggleCharm(6 /* DiagnosticsCharm */);
                    lazySetSelectedPivot
                        .import()
                        .then(function (setSelectedPivot) {
                        return setSelectedPivot(SEARCH_DIAGNOSTICS_PANEL_KEY);
                    });
                } },
                React.createElement(Icon, { iconName: "DeveloperTools" /* DeveloperTools */, className: styles.linkIcon }),
                unlocalizedStrings.viewDiagnosticsLink,
                ' ',
                lastSearchRequestTime ? searchTimeString : '')));
    };
    SearchInContextFeedbackDialog.prototype.showSearchInContextFeedbackDialog = function (userVoiceTeam) {
        showUserVoiceSuggestionDialog({
            title: unlocalizedStrings.ticketTitle,
            feedbackType: 7 /* SearchInContextFeedback */,
            header: unlocalizedStrings.dialogTitle,
            blurbElement: React.createElement("div", null),
            textAreaPlaceHolder: unlocalizedStrings.feedbackCommentsPlaceholder,
            customTags: getSearchFeedbackCustomTags(userVoiceTeam),
        }).then(function (response) {
            if (response === DialogResponse.ok) {
                sendSearchFeedback(userVoiceTeam);
            }
        });
    };
    SearchInContextFeedbackDialog = tslib_1.__decorate([
        observer
    ], SearchInContextFeedbackDialog);
    return SearchInContextFeedbackDialog;
}(React.Component));
export default SearchInContextFeedbackDialog;
//# sourceMappingURL=SearchInContextFeedbackDialog.js.map